import { inject, Injectable } from "@angular/core";
import { CurrentRouteService } from "../routing/current-route.service";
import { AuthenticationTokenService } from "./authenticazion-token.service";
import { AuthHeaders } from "@nts/std/types";


@Injectable({ providedIn: 'root' })
export class AuthRequestService {
  private authenticationTokenService: AuthenticationTokenService = inject(AuthenticationTokenService);
  private currentRouteService: CurrentRouteService = inject(CurrentRouteService);


  async buildHeaders(initial?: HeadersInit): Promise<Headers> {
    const headers = new Headers(initial);

    if (!this.currentRouteService.isAuthenticatedRoute) {
      return headers;
    }

    const accessToken = await this.authenticationTokenService.getAccessToken();

    if (accessToken && !headers.has(AuthHeaders.AUTHORIZATION_HEADER_NAME)) {
      headers.set(AuthHeaders.AUTHORIZATION_HEADER_NAME, `Bearer ${accessToken}`);
    }

    if (accessToken) {
      const tenantId = await this.authenticationTokenService.getTenantId(accessToken);
      const enterpriseData = await this.authenticationTokenService.getEnterpriseData(tenantId);

      if (enterpriseData?.enterpriseId > 0 && !headers.has(AuthHeaders.ENTERPRISE_DATA_HEADER_NAME)) {
        const sanitizedEnterpriseData = { ...enterpriseData };

        if (sanitizedEnterpriseData.companyId === 0 || sanitizedEnterpriseData.companyId === -1) {
          delete sanitizedEnterpriseData.companyId;
        }

        headers.set(
          AuthHeaders.ENTERPRISE_DATA_HEADER_NAME,
          JSON.stringify(sanitizedEnterpriseData)
        );
      }
    }

    return headers;
  }
}